module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "maincateContent"
  }, [_c('div', {
    staticClass: "page-item"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n                  " + _vm._s(_vm.mainCateTitle) + "\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "tabnav"
  }, [(!_vm.isShowMoreBrand) ? _c('ul', [_c('li', {
    class: (_vm.brandMenuIndex == 0 ? 'on' : ''),
    on: {
      "click": function($event) {
        return _vm.brandMenu(0)
      }
    }
  }, [_vm._v("\n                          热门推荐\n                      ")]), _vm._v(" "), _vm._l((_vm.showBrandList), function(item, i) {
    return _c('li', {
      key: 'brand_' + i,
      class: (_vm.brandMenuIndex == item.value ? 'on' : ''),
      on: {
        "click": function($event) {
          return _vm.brandMenu(item.value)
        }
      }
    }, [_vm._v("\n                          " + _vm._s(item.name) + "\n                      ")])
  })], 2) : _vm._e(), _vm._v(" "), (!_vm.isShowMoreBrand) ? _c('a', {
    staticClass: "showmore",
    on: {
      "click": function($event) {
        return _vm.setBrandShow(true)
      }
    }
  }, [_vm._v("展开"), _c('i', {
    staticClass: "icon icon-list"
  })]) : _vm._e(), _vm._v(" "), (_vm.isShowMoreBrand) ? _c('ul', {
    staticStyle: {
      "flex-wrap": "wrap"
    }
  }, [_c('li', {
    class: (_vm.brandMenuIndex == 0 ? 'on' : ''),
    on: {
      "click": function($event) {
        return _vm.brandMenu(0)
      }
    }
  }, [_vm._v("\n                          热门推荐\n                      ")]), _vm._v(" "), _vm._l((_vm.brandList), function(item, i) {
    return _c('li', {
      key: 'brand_' + i,
      class: (_vm.brandMenuIndex == item.value ? 'on' : ''),
      on: {
        "click": function($event) {
          return _vm.brandMenu(item.value)
        }
      }
    }, [_vm._v("\n                          " + _vm._s(item.name) + "\n                      ")])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.isShowMoreBrand) ? _c('a', {
    staticClass: "showmore",
    on: {
      "click": function($event) {
        return _vm.setBrandShow(false)
      }
    }
  }, [_vm._v("收缩"), _c('i', {
    staticClass: "icon icon-list1"
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "tabcontent",
    attrs: {
      "element-loading-text": "加载中..."
    }
  }, [_c('ul', _vm._l((_vm.goods), function(item, i) {
    return _c('li', {
      key: i
    }, [_c('div', {
      staticClass: "productIamge"
    }, [_c('img', {
      attrs: {
        "src": item.defaultImage
      },
      on: {
        "click": function($event) {
          return _vm.toDetail(item.id)
        }
      }
    }), _vm._v(" "), _vm._l((item.labels), function(labelItem, labelIndex) {
      return (labelIndex < 1 && labelItem.labelIcon) ? _c('img', {
        key: labelIndex,
        staticClass: "productIcon",
        attrs: {
          "src": labelItem.labelIcon
        }
      }) : _vm._e()
    })], 2), _vm._v(" "), _c('div', {
      staticClass: "productname"
    }, [_vm._v("\n                                  " + _vm._s(item.name) + "\n                              ")]), _vm._v(" "), _c('div', {
      staticClass: "productprice"
    }, [_c('span', {
      staticClass: "price"
    }, [_vm._v("\n                                    ￥" + _vm._s(item.settlementPrice) + "\n                                    "), (item.settlementPrice < item.sellPrice) ? _c('span', {
      staticClass: "scribe"
    }, [_vm._v("\n                                      ￥" + _vm._s(item.sellPrice) + "\n                                  ")]) : _vm._e()]), _vm._v(" "), _c('span', {
      staticClass: "sales"
    }, [_vm._v("\n                                      成交" + _vm._s(item.sales) + "件\n                                   ")])]), _vm._v(" "), _c('div', {
      staticClass: "operationBtn"
    }, [_c('a', {
      on: {
        "click": function($event) {
          return _vm.toDetail(item.id)
        }
      }
    }, [_c('y-button', {
      attrs: {
        "text": "查看详情"
      }
    })], 1), _vm._v(" "), _c('y-button', {
      attrs: {
        "text": "加入购物车",
        "classStyle": "main-btn"
      },
      on: {
        "btnClick": function($event) {
          return _vm.showModal(item)
        }
      }
    })], 1)])
  }), 0)]), _vm._v(" "), (!_vm.noResult && !_vm.error) ? _c('el-pagination', {
    attrs: {
      "page-size": _vm.pageSize,
      "current-page": _vm.currentPage3,
      "layout": "prev, pager, next, jumper",
      "total": _vm.goodsTotal
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange,
      "update:currentPage": function($event) {
        _vm.currentPage3 = $event
      },
      "update:current-page": function($event) {
        _vm.currentPage3 = $event
      }
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('selectSpec', {
    ref: "selectSpec"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f6fa9096","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/search/mainCate.vue
// module id = 793
// module chunks = 2